import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '../../shared/Table/Table';
import { columns, mapData } from './TableMetadata';
import combineStyles from '../../../helpers/combineStyles';
import parseQuerystring from '../../../helpers/parseQuerystring';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import SpacingStyles from '../../../styles/helpers/spacing';
import ListsStyle from '../__styles__/Lists.style';
import classnames from 'classnames';
import { DEFAULT_ROWS_PER_PAGE } from '../../../constants/request_constants';
import FormModal from './modals/FormModal';
import Button from '@material-ui/core/Button';
import Filters from './Filters';
import { subcategory } from '../../../constants/enums.js';

class QuotaConfigurationList extends React.PureComponent {
  state = {
    rowsPerPage: sessionStorage.getItem('BrillaRowsPerPage')
      ? parseInt(sessionStorage.getItem('BrillaRowsPerPage'), 10)
      : DEFAULT_ROWS_PER_PAGE,
    currentConfig: {
      stratum: '--',
      stratumQuota: '--',
      rolloverQuota: '--'
    }
  };

  componentDidMount() {
    this._fetchData();
  }

  _fetchData(params = {}) {
    this._fetchConfigs(params);
  }

  _fetchConfigs = params => {
    const query = params || parseQuerystring(this.props) || {};
    this.props.fetchAssignedQuotasList({
      ...query,
      page: query.page || 1,
      perPage: this.state.rowsPerPage
    });
  };

  _handleChangePage = page => {
    const query = parseQuerystring(this.props) || {};
    this._fetchConfigs({
      ...query,
      page: page + 1
    });
  };

  _handleChangeRowsPerPage = rowsPerPage => {
    sessionStorage.setItem('BrillaRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 1 }, this._fetchConfigs);
  };

  _getTableName = () => {
    const { configs = [] } = this.props;
    return configs.length != 1 ? 'Configuraciones' : 'Configuración';
  };

  _openModal = (params = {}) => {
    this.props.openFormModal();
    this.setState({
      currentConfig: this._getCurrentConfig(params.config)
    });
  };

  _closeModal = () => {
    this.props.closeFormModal();
  };

  _isLoadingData = () => {
    const { loading = false, loadingData = false } = this.props;
    return loading || loadingData;
  };

  _getCurrentConfig = config => {
    return config;
  };

  _handleRowClick = config => {
    if (this.props.canUpdateAssignedQuotas) {
      this._openModal({ config });
    }
  };

  _formButtonIsVisible = () => {
    return this.props.canCreateAssignedQuotas;
  };

  render() {
    const {
      configs = [],
      meta = {},
      classes,
      modalSubmitLoading = false,
      updateConfig,
      formModalIsOpen,
      geographicLocations,
      loadingData,
      createAssignedQuota,
      deleteAssignedQuota,
      modalSecondSubmitLoading = false,
      canDeleteAssignedQuotas
    } = this.props;
    const { currentPage } = meta;
    const { rowsPerPage } = this.state;
    return (
      <div>
        <div className={classes.titleRootWrapper}>
          <h1 className={classnames(classes.headline4, classes.title)}>
            {'Configuración de cupos'}
          </h1>
          {this._formButtonIsVisible() && (
            <Button
              className={classes.button}
              classes={{
                label: classes.buttonLabel
              }}
              variant="contained"
              color="secondary"
              onClick={() => this._openModal()}
            >
              {'Crear Configuración'}
            </Button>
          )}
        </div>
        <div className={classes.filterOptionsWrapper}>
          <Filters
            onChangeFilter={this._fetchConfigs}
            geographicLocations={geographicLocations}
            contractStrata={subcategory}
          />
        </div>
        <div>
          <Table
            name={this._getTableName()}
            columns={columns}
            data={mapData(configs)}
            onChangePage={this._handleChangePage}
            onChangePageRowsPerPage={this._handleChangeRowsPerPage}
            page={currentPage - 1}
            rowsPerPage={this.state.rowsPerPage}
            totalCount={(meta && meta.totalCount) || 0}
            loading={this._isLoadingData()}
            onClickOnRow={this._handleRowClick}
          />
        </div>
        <div>
          {formModalIsOpen && (
            <FormModal
              onClose={this._closeModal}
              config={this.state.currentConfig}
              deleteConfig={deleteAssignedQuota}
              modalSecondSubmitLoading={modalSecondSubmitLoading}
              updateConfig={updateConfig}
              createConfig={createAssignedQuota}
              submitLoading={modalSubmitLoading}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              geographicLocations={geographicLocations}
              loadingData={loadingData}
              canDeleteAssignedQuotas={canDeleteAssignedQuotas}
              query={parseQuerystring(this.props)}
              contractStrata={subcategory}
            />
          )}
        </div>
      </div>
    );
  }
}

const styles = () => ({});

export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    ListsStyle,
    styles
  )
)(QuotaConfigurationList);
